module.exports = __webpack_public_path__ + "res/roboto-v15-latin-regular.woff2";


//////////////////
// WEBPACK FOOTER
// ./client/app/vendor/googlefonts/roboto-v15-latin-regular.woff2
// module id = 108
// module chunks = 1